import { Component, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { BanksyncDetail, DraftIncomeSource, parseDraftDetail } from 'src/app/models/income-wizard-workflow';

@Component({
  selector: 'app-banksync-wizard-detail',
  templateUrl: './banksync-wizard-detail.component.html',
  styleUrls: ['./banksync-wizard-detail.component.less'],
  animations: [
    trigger('cardEnter', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(12px)' }),
        animate('280ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ]),
  ],
})
export class BanksyncWizardDetailComponent {
  @Input() applicantName = '';
  @Input() drafts: DraftIncomeSource[] = [];

  private get firstDetail(): BanksyncDetail | null {
    return this.drafts.length > 0 ? parseDraftDetail<BanksyncDetail>(this.drafts[0]) : null;
  }

  get subStreamCount(): number {
    return this.drafts.length;
  }

  get grossMonthlyAverage(): number | null {
    const total = this.drafts.reduce((sum, d) => sum + (d.suggestedAmount ?? 0), 0);
    return total > 0 ? total : null;
  }

  get accountTypeLabel(): string {
    const first = this.drafts[0];
    if (first?.subType === 2) return 'Savings Account';
    return 'Checking Account';
  }

  get institutionName(): string {
    return this.firstDetail?.institutionName ?? '';
  }

  get accountName(): string {
    return this.firstDetail?.accountName ?? '';
  }

  get currentBalance(): number | null {
    return this.firstDetail?.currentBalance ?? null;
  }

  get streamPersonName(): string {
    return this.applicantName;
  }

  get nameMatches(): boolean {
    return true;
  }
}
